import React from "react";
import BgPick from "../../images/pickDrop.png";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseURL } from "../../constants/Api";
import SuccessIcon from "../../images/success.svg";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import BackButton from "../bars/BackButton";
import { checkPastTime, fetchRoomNoAndPhoneNo, setRoomNoAndPhoneNo, validatePhoneNumber } from "../../utils/util";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import TextField from '@mui/material/TextField';
import dayjs, { Dayjs } from 'dayjs';
import { Box } from '@mui/material';
import { PickNDropPageView, PickNDropSubmitButtonClick } from "../../utils/Analytics";
function PickNdrop() {
  const navigate = useNavigate();
  const location = useLocation();
  const Date_from_history = location.state?.pickanddropdata
  console.log("Date_from_history",Date_from_history)
  const touristLocation = location.state?.place;
  const [hotelGuideData, SethotelGuideData] = useState([]);
  const currenturl = window.location.href;
  const urlArray = currenturl.split("/");
  const reservationId = localStorage.getItem("reservationId");
  const guestId = localStorage.getItem("guestId");
  const hotelId = localStorage.getItem("hotel-id");
  const appUserId = localStorage.getItem("appUserId");
  const [place, setPlace] = useState(location.state?.pickanddropdata?.pickUpLocation ? location.state?.pickanddropdata?.pickUpLocation : "");
  const [destiny, setDestiny] = useState(touristLocation|| location.state?.pickanddropdata?.destination || "");
  const storedData = fetchRoomNoAndPhoneNo();
   
  const [mobile, setMobile] = useState(storedData?.phone ? storedData?.phone : localStorage.getItem("phone_no"));
  const [comment, setComment] = useState(location.state?.pickanddropdata?.comment ? location.state?.pickanddropdata?.comment : "" );
  const [pickRequest, setPickRequest] = useState(false);
  const [alertMsg, SetAlertMsg] = useState("");

  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, "0");
  const day = String(currentDate.getDate()).padStart(2, "0");
  const hours = String(currentDate.getHours()).padStart(2, "0");
  const minutes = String(currentDate.getMinutes()).padStart(2, "0");
  const seconds = String(currentDate.getSeconds()).padStart(2, "0");
  const [date, setDate] = useState(location.state?.pickanddropdata?.dateTime?.split(" ")[0] || `${year}-${month}-${day}`);
  const [time, setTime] = useState(`${hours}:${minutes}:${seconds}`);
  const InitialDate = `${year}-${month}-${day}`;
  const InitialTime = `${hours}:${minutes}:${seconds}`;
  const reservationData = JSON.parse(localStorage.getItem("guestDetailsArray"));
  var datetime = new Date(reservationData.dateOut);
  // const [mobileValidation, setMobileValidation] =  useState(true);
  // Initialize with dayjs() wrapped in a function
 const [isSubmit,setisSubmit] = useState(false);

  const pickAndDropData = location?.state?.pickanddropdata?.dateTime;
  let parsedDate = null;
  if(pickAndDropData){

    parsedDate =  dayjs(pickAndDropData) ;
    const details = pickAndDropData
        ? {
              $L: 'en',
              $u: undefined,
              $d: parsedDate.toDate(), // JavaScript Date object
              $y: parsedDate.year(),
              $M: parsedDate.month(), // Month (0-indexed: December = 11)
              $date: parsedDate.date(), // Day of the month
          }
        : {};
  }

  
  const [timeValue, setTimeValue] = useState( parsedDate || null)
  const [selectedTime, setSelectedTime] = useState( location?.state?.pickanddropdata?.dateTime.split(" ")[1] || ""); // State to hold the selected time
  

  // Extracting the date part
  const today = dayjs().format('YYYY-MM-DD');
     var date_out =  datetime.toISOString().split("T")[0];
  const handleDate = (e) => {
    setDate(e.target.value);
    SetAlertMsg("");
    setTime(null);
  };

  console.log("setDate",date)


  console.log("selectedTime",selectedTime)
  console.log("timeValue",timeValue)

  const handleTimeChange = (newValue) => {
    if (newValue) {
      const formattedTime = dayjs(newValue).format('HH:mm:ss'); // Format the time to 'HH:mm:ss'
    
      console.log(newValue, formattedTime,"ddd")
      setTimeValue(newValue);
      setSelectedTime(formattedTime);
    } else {
      setSelectedTime(null); // Handle case when no valid time is selected
    }
  };
  const minTime = dayjs().startOf('minute');
  const handlePlace = (e) => {
    setPlace(e.target.value);
    SetAlertMsg("");
  };

  const handleDestiny = (e) => {
    setDestiny(e.target.value);
    SetAlertMsg("");
  };

  const handleMobile = (e) => {
    const value = e.target.value;
      if (/^[0-9+-]*$/.test(value)) {
        setMobile(value);
      }
    SetAlertMsg("");
    // setMobileValidation(validatePhoneNumber(e.target.value))
  };

  const handleComment = (e) => {
    setComment(e.target.value);
    SetAlertMsg("");
  };

  const pickDrop = async () => {
    var data = {
      guestId,
      hotelId,
      reservationId,
      pickUp: place,
      destination: destiny,
      mobileNumber: mobile,
      date: date,
      time: selectedTime,
      message: comment,
      appUserId,    
    };
    //append id to the data object for knowing it is for editing not for creating new pick and drop
    if (location.state?.pickanddropdata?.id) {
      data.id = location.state.pickanddropdata.id;
    }
    
    let config = {
      method: "post",
      url: `${baseURL}/api/chauffeurBookingV21`,
      data: data,
      headers: {
        "Content-Type": "application/json",
      },
    };
    try {
      const response = await axios.request(config);
      console.log(data);
      if (response.data.success) {
        setPickRequest(true);
        SetAlertMsg("success");
        setTimeout(() => {
          SetAlertMsg("");
          navigate('../order-history');
          setisSubmit(false);
        }, 2000);
        setDate("");
        setTime("");
        setPlace("");
        setDestiny("");
        setMobile("");
        setComment("");
        setRoomNoAndPhoneNo(null,mobile);
   
      } else {
        setPickRequest(true);
        SetAlertMsg("Please enter required fields.");
        setisSubmit(false);
      }
    } catch (error) {
      console.log(error);
      setisSubmit(false);
    }
  };


  const handlePickDrop = (e) => {
    // setisSubmit(true);
 if(isSubmit === false){
    e.preventDefault();
    SetAlertMsg("");

    if (
      date === "" ||
      selectedTime === "" ||
      mobile === "" ||
      destiny === "" ||
      place === ""
      // || !mobileValidation 
    ) {
      SetAlertMsg("validation");
    } 
    else if(!selectedTime){
      SetAlertMsg("timeCheck");
    }
    else if(checkPastTime(date,selectedTime)){
      SetAlertMsg("timeCheck");
    }
    else {
      setisSubmit(true);
      PickNDropSubmitButtonClick();
      pickDrop();
    }
  }
  };

  const handleClose = () => {
    setPickRequest(false);
  };

  useEffect(() => {
      PickNDropPageView();
     }, []);

  return (
    <div>
      <div className="pb-28 relative dark-modal">
        <div
          style={{
            width: "100%",
            height: "150px",
            maxHeight: "200px",
            backgroundImage: `url(${BgPick})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        ></div>
        <div className="absolute top-3 left-3">
          <BackButton whiteTheme={true}  />
        </div>
        <div className="section-wrap mx-4 mt-6 sm:mt-14">
          <div className="guestName sm:text-center text-left">Request</div>
          <div className="mt-3 text-base font-semibold">Pick And Drop</div>
          <form className="flex flex-col">
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Preferred Date
            </label>
            <input
              className="mt-2 reqInput"
              type="date"
              value={date}
              min={InitialDate}
              max={date_out}
              onChange={handleDate}
              required
            />
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Preferred Time
            </label>
            <Box sx={{ width: '100%' }}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                   <TimePicker
                    fullWidth
                    value={timeValue}
                    onChange={(val)=>handleTimeChange(val)}
                    slotProps={{ textField: { placeholder: 'Please select the time' } }}
                    sx={{
                      '& .MuiInputBase-root': {
                        borderRadius: '4px',
                        background: '#342f4f',
                        outline: 'none',
                        padding: '10px 16px',
                        border: 'none',
                        color: '#fff',
                        width: '100%',
                      },
                      '& .MuiInputBase-input': {
                        padding: '0',
                        color: 'inherit',
                        borderRadius: '4px',
                      },
                      '& .MuiSvgIcon-root': {
                        color: '#fff',
                      },
                      '&.Mui-focused .MuiInputBase-root': {
                        borderColor: 'transparent',
                        boxShadow: 'none',
                      },
                      '&:hover .MuiInputBase-root': {
                        borderColor: 'transparent',
                      },
                      // '& input::placeholder': {
                      //   fontSize:'16px',
                      //   fontFamily:'inherit',
                      //   fontFeatureSettings: 'inherit', // Inherit font-feature-settings
                      //   fontVariationSettings: 'inherit',
                      //   fontWeight: 'lighter',
                      // },
                    }}
                  /> 
                </Box>
              </LocalizationProvider>
            </Box>
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Pickup location
            </label>
            <input
              className="mt-2 reqInput"
              placeholder="Enter your pick up point"
              type="location"
              value={place}
              onChange={handlePlace}
              required
            />
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Destination
            </label>
            <input
              className="mt-2 reqInput"
              placeholder="Enter your destination point"
              type="text"
              value={destiny}
              onChange={handleDestiny}
              required
            />
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Phone number
            </label>
            <input
              className="mt-2 reqInput"
              placeholder="Enter your phone number"
              type="text"
              value={mobile}
              onChange={handleMobile}
              required
            />
           {/* {!mobileValidation &&<div className="text-sm mt-1 text-red-500">Invalid mobile number</div>} */}
            <label className="mt-4 text-left text-[#D0D0D0] text-12px font-normal">
              Comment if any
            </label>
            <textarea
              className="mt-2 reqInput"
              type="textarea"
              value={comment}
              onChange={handleComment}
              required
            />
            <button
            // setisSubmit(true);
              className={`bookBtn mt-10 max-w-[400px] ${isSubmit ? 'opacity-50 cursor-not-allowed' : " "}`}
              onClick={handlePickDrop}
              disabled={isSubmit}
            >
              {location.state?.pickanddropdata? "Update Request" : "Request Taxi"}
            </button>
          </form>
        </div>
      </div>

      <div className="mt-10 fixed  bottom-5 left-1/2 -translate-x-1/2">
        {alertMsg == "validation" && (
          <div className="w-full flex justify-center">
            <div className="error-doc text-center mt-3 whitespace-nowrap">
              Please enter required fields.
            </div>
          </div>
        )}

        {alertMsg == "timeCheck" && (
                <div className="w-full flex justify-center">
                  <div className="error-doc text-center mt-3 whitespace-nowrap">
                  Pick and drop service is not available for the chosen time.
            </div>
          </div>
        )}
 
        {alertMsg == "axios" && (
          <div className="w-full flex justify-center">
            <div className="error-doc text-center mt-3">
              Somthing went wrong..
            </div>
          </div>
        )}

    {alertMsg != "axios" && alertMsg != "timeCheck"  && alertMsg != "success"  && alertMsg != "validation" && alertMsg && (
              <div className="w-full flex justify-center">
                <div className="error-doc text-center mt-3">
                  {alertMsg}
                </div>
          </div>
        )}
        {alertMsg == "success" && (
          <div className="w-full flex justify-center">
            <div className="success-doc text-center mt-3">
              Successfully booked
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default PickNdrop;
